// src/components/lead/sections/help/AdminHelp.tsx

export function AdminHelp() {
  return (
    <div className="text-blue-900">Approve users and assign roles for your organization.</div>
  );
}
